import React, { useRef, useEffect, useState } from "react";
import { Button } from "antd";
import nmp_mapboxgl from "@neshan-maps-platform/mapbox-gl";
import "@neshan-maps-platform/mapbox-gl/dist/NeshanMapboxGl.css";

import Classes from "./index.module.css";

const MapComponent = React.forwardRef(({ action, child = [],buttonLoading=false }, ref) => {
  const mapContainerRef = useRef(null);

  

  
  useEffect(() => {
    if (mapContainerRef.current && ref) {
      const map = new nmp_mapboxgl.Map({
        mapType: nmp_mapboxgl.Map.mapTypes.neshanVector,
        container: mapContainerRef.current,
        zoom: 16,
        pitch: 0,
        center: [57.054786447366695, 30.284282935505516],
        minZoom: 2,
        maxZoom: 22,
        trackResize: true,
        mapKey: "web.68445b6ce4ca44368aee86d19e921720",
        poi: true,
        traffic: true,
        mapTypeControllerOptions: {
          show: true,
          position: "bottom-left",
        },
      });

      // Now, set the map instance to the forwarded ref
      ref.current = map;
    }
  }, [ref]);
  return (
    <>
      <div className={Classes.map} ref={mapContainerRef} />
      <Button
        className={Classes.MapButton}
        type="primary"
        shape="circle"
        icon={<i className="fa fa-play" />}
        size={"large"}
        loading={buttonLoading}
        onClick={action}
      />
    </>
  );
});

export default MapComponent;
